// extracted by mini-css-extract-plugin
export var growableInput = "_3r-0";
export var tagContainer = "_3r-2";
export var textInput = "_3r-1";